<template>
  <div style="background-color: #fafafa;">
    <div class="searchBox">
      <van-search class="search-box" background="#2D7FC7" shape="round" v-model="value" placeholder="搜索物料名称" show-action @search="onSearch" @input="onSearch"
                  @cancel="onSearch" @clear="onSearch">
      </van-search>
    </div>
    <div class="box" style="margin-top: 5em;color: black;">
      <table class="layout" style="width: 100%;" >
        <tr style="width: 100%;">
          <td colspan="2" style="width: 100%;">
            <p><span>货品名称：</span><span>{{this.$route.query.radName}}</span></p>
            <p><span>图号：</span><span>{{this.$route.query.formulaName}}</span></p>
            <p><span>客户名称：</span><span>{{this.$route.query.dealerIdname}}</span></p>
            <p><span>规格(高宽厚)：</span><span>{{this.$route.query.custom_text_1}}</span></p>
            <p><span>排档方式：</span><span>{{this.$route.query.custom_text_2}}</span></p>
            <p><span>主管规格：</span><span>{{this.$route.query.custom_text_3}}</span></p>
            <p><span>档距_头距_空位间距：</span><span>{{this.$route.query.custom_dropdown_1}}</span></p>
            <p><span>表面处理：</span><span>{{this.$route.query.colorname}}</span></p>
            <p><span>特殊进出水方式：</span><span>{{this.$route.query.isSpecials}}</span></p>
            <p><span>中心距：</span><span>{{this.$route.query.centerSpacing}}</span></p>
            <p><span>片数：</span><span>{{this.$route.query.pieces}}</span></p>
            <p><span>档管规格：</span><span>{{this.$route.query.custom_text_4}}</span></p>
            <p><span>接口口径：</span><span>{{this.$route.query.calibername}}</span></p>
            <p><span>进水方式：</span><span>{{this.$route.query.waterFlowname}}</span></p>
            <p><span>是否防腐：</span><span>{{this.$route.query.custom_dropdown_2name}}</span></p>
          </td>
        </tr>
      </table>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-top: 0">
      <van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
        <div style="width: 100%;" v-for="(item) in list" class="card" :key="item.uuid">
          <table class="layout" style="width: 100%;" >
            <tr style="width: 100%;">
              <td style="width: 60%;">
                <div class="header">
                  <span class="title">{{item.serialNumber}}</span>
                </div>
              </td>
            </tr>
            <tr style="width: 100%;">
              <td colspan="2" class="content" style="width: 100%;">
                <p><span>物料名称：</span><span>{{item.name}}</span></p>
                <p><span>规格：</span><span>{{item.specs}}</span></p>
                <p><span>物料编码：</span><span>{{item.custom_text_04}}</span></p>
              </td>
            </tr>
            <tr style="width: 100%;">
              <td class="content" style="width: 50%;">
                <p><span>组件名称：</span><span>{{item.typename}}</span></p>
                <p><span>单位：</span><span>{{item.unit}}</span></p>
                <p><span>制程：</span><span>{{item.custom_text_07name}}</span></p>
                <p><span>生产性质：</span><span>{{item.custom_dropdown_07name}}</span></p>
              </td>
              <td class="content" style="width: 50%;">
                <p><span>代码：</span><span>{{item.code}}</span></p>
                <p><span>材质：</span><span>{{item.custom_text_06}}</span></p>
                <p><span>长度：</span><span>{{item.length}}</span></p>
                <p><span>数量：</span><span>{{item.quantity}}</span></p>
              </td>
            </tr>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="showFilter" closeable position="bottom" :style="{ height: '80%' }"
               :close-on-click-overlay="false">
      <van-nav-bar title="申请时间" left-text="取消" right-text="确定"
                   @click-left="onFilterClickLeft()" @click-right="onFilterClickRight()" />
      <table class="layout">
        <tr>
          <td>
            <van-field-date v-model="startTime" type="date" format="yyyy-MM-dd" label="开始日期"></van-field-date>
            <van-field-date v-model="endTime" format="yyyy-MM-dd" type="date" label="结束日期"></van-field-date>
          </td>
        </tr>
      </table>
    </van-popup>
  </div>
</template>

<script>
import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Icon} from 'vant';
import bomListService from "../../service/bomListService";
import VanFieldDate from "../../components/VantFieldDate";
import {formatDictionary} from "../../utils/dictionary";
import moment from "moment";
export default {
  data: function () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      value: '',
      showFilter: false,
      startTime: "",
      endTime: "",
      bomId: this.$route.query.bomId,
    }
  },

  components: {
    VanFieldDate,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
  },
  computed:{
    userId() {
      return this.$store.getters.getUserId;
    }
  },
  methods: {
    async onLoad() {
      this.pageIndex++;
      let resp = await bomListService.getBomDetailList(this.pageIndex,this.bomId, this.value, this.startTime, this.endTime);
      resp.data.Data.data.forEach(item => {
        item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
      });
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onSearch() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    showFilterPop(){
      this.showFilter = true;
    },
    onFilterClickLeft(){
      this.showFilter = false;
    },
    onFilterClickRight(){
      this.showFilter = false;
      this.onSearch();
    },
  }
};

</script>
<style>
.card p {
  margin:10px 0;
}
.card p>span:first-child {
  flex: 0 0 4rem;
  text-align: right;
  margin-right: 20px;
}
.van-pull-refresh__head{
  display: none;
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom:0;
  position:fixed;
  width: 100%;
}
.psiConfirmCont{
  width:100%;
  margin:0 auto;
  overflow: hidden;

}
.searchBox {
  height: 3rem;
  box-sizing: border-box;
  margin-bottom: 2rem;
  top: 0;
  position:fixed;
  width: 100%;
  background-color: #2D7FC7;
  z-index:999;
}
</style>